module.exports = __webpack_public_path__ + "static/media/ic_twitter.c4a73ed2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/share-fb-twitter/ic_twitter.svg
// module id = 219
// module chunks = 0